import { Helmet } from '@dr.pogodin/react-helmet';

const SITE_URL = 'https://cbaiq.com';
const DEFAULT_IMAGE = `${SITE_URL}/cbaiq-logo.png`;

/**
 * Reusable per-page SEO component.
 * Sets unique title, meta description, canonical, Open Graph, Twitter Card,
 * robots directive, and optional JSON-LD structured data.
 */
export const Seo = ({ title, description, path = '/', type = 'website', image, noindex = false, jsonLd }) => {
  const canonical = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content="CBAIQ" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
